import { BreakpointObserver, Breakpoints, MediaMatcher } from '@angular/cdk/layout';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Injector,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { AuthGuard } from '../../../../shared/auth/auth.guard';
import { AuthService } from '../../../../shared/auth/auth.service';
import { NavigationEnd, Router } from '@angular/router';
import { filter, Observable, Subscription } from 'rxjs';
import { ComponentService } from '../../../../shared/abstract/component.service';
import { RequestService } from '../../../../shared/services/request.service';
import { FormType } from '../../../../shared/enum/form-type';
import { MatSidenav } from '@angular/material/sidenav';
import { MatSelectChange } from '@angular/material/select';
import { UserFormTemplate } from '../../../../shared/entities/user-form-template';
import { TutorialTriggerService } from '../../../../shared/services/tutorial-trigger.service';

@Component({
  selector: 'app-sidemenu',
  templateUrl: './sidemenu.component.html',
  styleUrl: './sidemenu.component.css',
})
export class SidemenuComponent
  extends ComponentService<any>
  implements OnInit, AfterViewInit
{
  public mobileQuery: MediaQueryList;
  @Input() isSidenavOpened: boolean = false; // Handle sidenav state
  @ViewChild('sidenav', { static: true }) sidenav!: ElementRef;
  displayedProjects: any[] = [];

  private itemsPerPage = 10;
  private currentPage = 1;
  opened: boolean = false;
  sidenavWidth = 20;
  openedSidenavWidth = 20;
  closedSidenavWith = 3;
  ngStyle!: string;
  sideMenuList: any = [];
  public isShowSidebar: boolean;
  workForms: any = [];
  defaultForms: any = [];
  teamForms: any = [];
  regionForms: any = [];
  poiForms: any = [];
  depotForms: any = [];
  projects: any = [];
  selectedWorkForm: any;
  selectedTeamForm: any;
  selectedPoiForm: any;
  selectedProjectId: any;
  selectedProjectName: any;
  selectedRegionForm: any;
  selectedDefaultForm: any;
  selectedDepotForm: any;
  disableMouseLeave = false;
  showProjectsContainer: boolean = false;
  isInteractingWithChild = false;
  subscription!: Subscription;
  searchProjectName: string = '';
  truncateLimit = 0;
  @Output() notify = new EventEmitter<string>();


  private mobileQueryListener: () => void;

  constructor(
    injector: Injector,
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private _authGuard: AuthGuard,
    private http: HttpClient,
    private _auth: AuthService,
    private _router: Router,
    private _request: RequestService,
    private breakpointObserver: BreakpointObserver,
    private tutorialTrigger: TutorialTriggerService

  ) {
    super(injector);
    this.mobileQuery = media.matchMedia('(max-width: 430px)');
    this.mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this.mobileQueryListener);

    this.isShowSidebar = !this.mobileQuery.matches;
  }
  notifyParent(operation:any) {
    this.notify.emit(operation);
  }

  getSidenavWidth(): string {
    if (this.mobileQuery.matches) {
      return this.isSidenavOpened ? '100vw' : `${this.closedSidenavWith}em`;
    } else {
      return `${this.sidenavWidth}em`;
    }
  }

  ngOnInit(): void {
    this.sideMenuList = this.adminSideMenuAuthControl();
    
    if (this._router.url === '/admin' || this._router.url === '/admin/') {
      this._router.navigate(["/admin/" + this.sideMenuList[0].path]);
    }
    
    this.projects = this._appsService.projects;
    this.selectedProjectId = this._appsService.selectedProject;

    this.setTruncateLimit();
    this.subscription = this._appsService.projectData.subscribe((res) => {
      if (res) {
        this.selectedProjectName = this._appsService.projects?.find(
          (x) => x.id == res
        ).projectName;
        this.selectedProjectId = res;
      }
    });

    this._request.getForms(
      this._appsService.existCurrentProject?.companyId,
      false,
      false,
      this._appsService.existCurrentProject?.projectId,
      null
    ).then(res => {
      this.workForms = res.filter((x) => x.templateTypeId == FormType.Work);
      this.poiForms = res.filter((x) => x.templateTypeId == FormType.Poi && x.isActive);
      this.regionForms = res.filter((x) => x.templateTypeId == FormType.Region && x.isActive);
      this.defaultForms = res.filter((x) => x.templateTypeId == FormType.Default);
      this.depotForms = res.filter((x) => x.templateTypeId == FormType.Depot && x.isActive);
      this.teamForms = res.filter((x) => x.templateTypeId == FormType.Team && x.isActive);

      var userFormTemplate = new UserFormTemplate();
      userFormTemplate.userId = this._appsService.userInfos.id
      userFormTemplate.projectId = this._appsService.selectedProject;

      //TEAM
      if (this._appsService.lastFormTemplateIds.teamTemplateId == 0 || this._appsService.lastFormTemplateIds.teamTemplateId == undefined) {
        this._appsService.selectedTeamForm = this.teamForms[0];
        this.selectedTeamForm = this._appsService.selectedTeamForm;
        if (this._appsService.selectedTeamForm != null) {
          userFormTemplate.formTemplateId = this._appsService.selectedTeamForm.id;
          userFormTemplate.formTemplateTypeId = this._appsService.selectedTeamForm.templateTypeId;
          this.addOrUpdateUserFormTemplate(userFormTemplate);

        }
      }
      else {
        this._appsService.selectedTeamForm = this.teamForms.find(x => x.id == this._appsService.lastFormTemplateIds.teamTemplateId);
        this.selectedTeamForm = this._appsService.selectedTeamForm;

        if (this._appsService.selectedTeamForm == null || this._appsService.selectedTeamForm == undefined) {
          //if selectedForm is deleted or updated set the first form as selected
          userFormTemplate.formTemplateId = this.teamForms[0].id;
          userFormTemplate.formTemplateTypeId = this.teamForms[0].templateTypeId;
          this._appsService.selectedTeamForm = this.teamForms[0];
          this.selectedTeamForm = this._appsService.selectedTeamForm;
          this.addOrUpdateUserFormTemplate(userFormTemplate);
        }

      }

      //POI
      if (this._appsService.lastFormTemplateIds.poiTemplateId == 0 || this._appsService.lastFormTemplateIds.poiTemplateId == undefined) {
        this._appsService.selectedPoiForm = this.poiForms[0];
        this.selectedPoiForm = this._appsService.selectedPoiForm;
        if (this._appsService.selectedPoiForm != null) {
          userFormTemplate.formTemplateId = this._appsService.selectedPoiForm.id;
          userFormTemplate.formTemplateTypeId = this._appsService.selectedPoiForm.templateTypeId;
          this.addOrUpdateUserFormTemplate(userFormTemplate);

        }
      }
      else {
        this._appsService.selectedPoiForm = this.poiForms.find(x => x.id == this._appsService.lastFormTemplateIds.poiTemplateId);
        this.selectedPoiForm = this._appsService.selectedPoiForm;

        if (this._appsService.selectedPoiForm == null || this._appsService.selectedPoiForm == undefined) {
          //if selectedForm is deleted or updated set the first form as selected
          userFormTemplate.formTemplateId = this.poiForms[0].id;
          userFormTemplate.formTemplateTypeId = this.poiForms[0].templateTypeId;
          this._appsService.selectedPoiForm = this.poiForms[0];
          this.selectedPoiForm = this._appsService.selectedPoiForm;
          this.addOrUpdateUserFormTemplate(userFormTemplate);
        }

      }


      //DEPOT
      if (this._appsService.lastFormTemplateIds.depotTemplateId == 0 || this._appsService.lastFormTemplateIds.depotTemplateId == undefined) {
        this._appsService.selectedDepotForm = this.depotForms[0];
        this.selectedDepotForm = this._appsService.selectedDepotForm;
        if (this._appsService.selectedDepotForm != null) {
          userFormTemplate.formTemplateId = this._appsService.selectedDepotForm.id;
          userFormTemplate.formTemplateTypeId = this._appsService.selectedDepotForm.templateTypeId;
          this.addOrUpdateUserFormTemplate(userFormTemplate);
        }
      }
      else {
        this._appsService.selectedDepotForm = this.depotForms.find(x => x.id == this._appsService.lastFormTemplateIds.depotTemplateId);
        this.selectedDepotForm = this._appsService.selectedDepotForm;

        if (this._appsService.selectedDepotForm == null || this._appsService.selectedDepotForm == undefined) {
          //if selectedForm is deleted or updated set the first form as selected
          userFormTemplate.formTemplateId = this.depotForms[0].id;
          userFormTemplate.formTemplateTypeId = this.depotForms[0].templateTypeId;
          this._appsService.selectedDepotForm = this.depotForms[0];
          this.selectedDepotForm = this._appsService.selectedDepotForm;
          this.addOrUpdateUserFormTemplate(userFormTemplate);
        }

      }


      //REGION
      if (this._appsService.lastFormTemplateIds.regionTemplateId == 0 || this._appsService.lastFormTemplateIds.regionTemplateId == undefined) {
        this._appsService.selectedRegionForm = this.regionForms[0];
        this.selectedRegionForm = this._appsService.selectedRegionForm;
        if (this._appsService.selectedRegionForm != null) {
          userFormTemplate.formTemplateId = this._appsService.selectedRegionForm.id;
          userFormTemplate.formTemplateTypeId = this._appsService.selectedRegionForm.templateTypeId;
          this.addOrUpdateUserFormTemplate(userFormTemplate);

        }
      }
      else {
        this._appsService.selectedRegionForm = this.regionForms.find(x => x.id == this._appsService.lastFormTemplateIds.regionTemplateId)
        this.selectedRegionForm = this._appsService.selectedRegionForm;

        if (this._appsService.selectedRegionForm == null || this._appsService.selectedRegionForm == undefined) {
          //if selectedForm is deleted or updated set the first form as selected
          userFormTemplate.formTemplateId = this.regionForms[0].id;
          userFormTemplate.formTemplateTypeId = this.regionForms[0].templateTypeId;
          this._appsService.selectedRegionForm = this.regionForms[0];
          this.selectedRegionForm = this._appsService.selectedRegionForm;
          this.addOrUpdateUserFormTemplate(userFormTemplate);
        }
      }


      //WORK
      if (this._appsService.lastFormTemplateIds.workTemplateId == 0 || this._appsService.lastFormTemplateIds.workTemplateId == undefined) {
        this._appsService.selectedWorkForm = this.workForms[0];
        this.selectedWorkForm = this._appsService.selectedWorkForm;
        if (this._appsService.selectedWorkForm != null) {
          userFormTemplate.formTemplateId = this._appsService.selectedWorkForm.id;
          userFormTemplate.formTemplateTypeId = this._appsService.selectedWorkForm.templateTypeId;
          this.addOrUpdateUserFormTemplate(userFormTemplate);

        }
      }
      else {
        this._appsService.selectedWorkForm = this.workForms.find(x => x.id == this._appsService.lastFormTemplateIds.workTemplateId);
        this.selectedWorkForm = this._appsService.selectedWorkForm

        if (this._appsService.selectedWorkForm == null || this._appsService.selectedWorkForm == undefined) {
          //if selectedForm is deleted or updated set the first form as selected
          userFormTemplate.formTemplateId = this.workForms[0].id;
          userFormTemplate.formTemplateTypeId = this.workForms[0].templateTypeId;
          this._appsService.selectedWorkForm = this.workForms[0];
          this.selectedWorkForm = this._appsService.selectedWorkForm;
          this.addOrUpdateUserFormTemplate(userFormTemplate);

        }
      }

      //DEFAULT
      if (this._appsService.lastFormTemplateIds.defaultTemplateId == 0 || this._appsService.lastFormTemplateIds.defaultTemplateId == undefined) {
        this._appsService.selectedDefaultForm = this.defaultForms[0];
        this.selectedDefaultForm = this._appsService.selectedDefaultForm;
        if (this._appsService.selectedDefaultForm != null) {
          userFormTemplate.formTemplateId = this._appsService.selectedDefaultForm.id;
          userFormTemplate.formTemplateTypeId = this._appsService.selectedDefaultForm.templateTypeId;
          this.addOrUpdateUserFormTemplate(userFormTemplate);
        }
      }
      else {
        //if previous selectedFormDeletedOrUpdated set the first one
        this._appsService.selectedDefaultForm = this.defaultForms.find(x => x.id == this._appsService.lastFormTemplateIds.defaultTemplateId);
        this.selectedDefaultForm = this._appsService.selectedDefaultForm;

        if (this._appsService.selectedDefaultForm == null || this._appsService.selectedDefaultForm == undefined) {
          //if selectedForm is deleted or updated set the first form as selected
          userFormTemplate.formTemplateId = this.defaultForms[0].id;
          userFormTemplate.formTemplateTypeId = this.defaultForms[0].templateTypeId;
          this._appsService.selectedDefaultForm = this.defaultForms[0];
          this.selectedDefaultForm = this._appsService.selectedDefaultForm;
          this.addOrUpdateUserFormTemplate(userFormTemplate);

        }
      }

    }).catch((error) => {
      console.error("An error occurred:", error);
    });
  }

  ngAfterViewInit() {
    this.projects = this._appsService.projects;

    this.selectedProjectName = this._appsService.projects?.find(
      (x) => x.id == this.selectedProjectId
    ).projectName;

    this.isSidenavOpened = !this.isSidenavOpened;
    this._router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        if (this.mobileQuery.matches) {
          this.notifyParent('toggle');
        }
        
      });




  }

  toggleSidenav() {
    if (this.sidenavWidth == this.openedSidenavWidth) {
      this.sidenavWidth = this.closedSidenavWith;
      this.expandedItems = {};
    } else {
      this.sidenavWidth = this.openedSidenavWidth;
    }

  }
  expandedItems: { [key: number]: boolean } = {}; // Store expanded state for each item

  toggleExpansion(index: number): void {
    this._appsService.logInfo(this.languageKey(this.sideMenuList[index].menuName) + " " + "görüntülendi");
    this.sideMenuList[index].dropState = !this.sideMenuList[index].dropState
  }

  onSideMenuItemClick(index: number): void {
    const sideMenuItem = this.sideMenuList?.[index];
    if (!sideMenuItem) return;
    const tag = sideMenuItem.tutorialId || ('tutorial-sidemenu-' + sideMenuItem.menuName);
    this.tutorialTrigger.emitTag(tag, { menuName: sideMenuItem.menuName, path: sideMenuItem.path }, 'sidemenu');
    this.toggleExpansion(index);
  }

  onSubMenuItemClick(subMenuItem: any): void {
    if (subMenuItem?.tutorialId) {
      this.tutorialTrigger.emitTag(
        subMenuItem.tutorialId,
        { menuName: subMenuItem.menuName, type: subMenuItem.type, operation: subMenuItem.operation },
        'sidemenu'
      );
    }
  }

  interact() {
    this.isInteractingWithChild = true;
  }

  leave(event: MouseEvent) {
    const relatedTarget = event.relatedTarget as HTMLElement;

    // Check if the related target is inside the sidenav or the dropdown
    if (relatedTarget && relatedTarget.closest('.cdk-overlay-container')) {
      return;
    }

    this.isInteractingWithChild = false;
  }

  increase() {
    //if (!this.disableMouseLeave && !this.isInteractingWithChild) {
    //  this.sidenavWidth = this.openedSidenavWidth;
    //}
    this.sidenavWidth = this.openedSidenavWidth;
  }

  decrease() {
    if (!this.isSidenavOpened && !this.isInteractingWithChild) {
      this.sidenavWidth = this.closedSidenavWith;
      this.showProjectsContainer = false;
      this.sideMenuList = this.adminSideMenuAuthControl();
    }
  }

  directDecrease() {
    this.sidenavWidth = this.closedSidenavWith;
    this.showProjectsContainer = false;
    this.sideMenuList = this.adminSideMenuAuthControl();
  }

  displayProjects() {
    this.showProjectsContainer = !this.showProjectsContainer

  }

  //decrease() {
  //  this.sidenavWidth = this.closedSidenavWith;
  //  this.sideMenuList = JSON.parse(JSON.stringify(sideMenuRoute));

  //}

  openSidenav(): void {
    this.opened = true;
  }

  // Method to close the sidenav
  closeSidenav(): void {
    this.opened = false;
  }

  onDropdownToggle() {}

  onSelectedProject(projectId: number) {
    //this._appsService.projects = this.projects;
    //this.onSelectedProject(this.projects[0].id);
    this.selectedProjectId = projectId;
    this._appsService.selectedProject = projectId;
    //this._appsService.projectData.next(projectId);
    this.selectedProjectName = this._appsService.projects?.find(
      (x) => x.id == this._appsService.selectedProject
    ).projectName;

    this._request.setCurrentProject(projectId).then((_) => {
      const p = this.projects.find((p) => p.id == projectId);
      p != null ? this._appsService.getCurrentProject(p) : false;
      this._appsService.getSettings();
    });
    this._appsService.logInfo(projectId + " id li proje görüntülendi");
    window.location.reload();
  }

  onItemSelected(type, event: MatSelectChange) {
    var message = '';
    var formTypeMessage = '';
    switch (type) {
      case FormType.Work:
        this._appsService.selectedWorkForm = this.selectedWorkForm;
        formTypeMessage = 'Varsayılan İş Formu';
        this._appsService.logInfo(this._appsService.selectedWorkForm.id + " id li iş formu varsayılan olarak ayarlandı");
        break;
      case FormType.Team:
        this._appsService.selectedTeamForm = this.selectedTeamForm;
        formTypeMessage = 'Varsayılan Takım Formu';
        this._appsService.logInfo(this._appsService.selectedTeamForm.id + " id li ekip formu varsayılan olarak ayarlandı");
        break;
      case FormType.Poi:
        this._appsService.selectedPoiForm = this.selectedPoiForm;
        formTypeMessage = 'Varsayılan Poi Formu';
        this._appsService.logInfo(this._appsService.selectedPoiForm.id + " id li poi formu varsayılan olarak ayarlandı");
        break;
      case FormType.Depot:
        this._appsService.selectedDepotForm = this.selectedDepotForm;
        formTypeMessage = 'Varsayılan Depo Formu';
        this._appsService.logInfo(this._appsService.selectedDepotForm.id + " id li depo formu varsayılan olarak ayarlandı");
        break;
      case FormType.Region:
        this._appsService.selectedRegionForm = this.selectedRegionForm;
        formTypeMessage = 'Varsayılan Bölge Formu';
        this._appsService.logInfo(this._appsService.selectedRegionForm.id + " id li bölge formu varsayılan olarak ayarlandı");
        break;
      case FormType.Default:
        this._appsService.selectedDefaultForm = this.selectedDefaultForm;
        formTypeMessage = 'Varsayılan Anket Formu';
        this._appsService.logInfo(this._appsService.selectedDefaultForm.id + " id li anket formu varsayılan olarak ayarlandı");
        break;
    }

    message =
      formTypeMessage + ' ' + event?.value?.templateName + ' olarak ayarlandı';
    this.MessageBox(message, 'primary', 'center');
  }

  dynamicOperations(type) {
    var formTemplateId: any;
    var templateVersion: any;
    var templateName: any;
    switch (type) {
      case FormType.Work:
        formTemplateId = this.selectedWorkForm?.id;
        templateVersion = this.selectedWorkForm?.templateVersion;
        templateName = this.selectedWorkForm?.templateName;
        this._appsService.logInfo(formTemplateId + " li forma ait işler listelendi");
        break;
      case FormType.Team:
        formTemplateId = this.selectedTeamForm?.id;
        templateVersion = this.selectedTeamForm?.templateVersion;
        templateName = this.selectedDepotForm?.templateName;
        this._appsService.logInfo(formTemplateId + " li forma ait ekipler listelendi");
        break;
      case FormType.Poi:
        formTemplateId = this.selectedPoiForm?.id;
        templateVersion = this.selectedPoiForm?.templateVersion;
        templateName = this.selectedDepotForm?.templateName;
        this._appsService.logInfo(formTemplateId + " li forma ait poiler listelendi");
        break;
      case FormType.PoiCategory:
        formTemplateId = 0;
        templateVersion = 0;
        templateName = 'Poi Kategori';
        this._appsService.logInfo(formTemplateId + " li forma ait poi kategoriler listelendi");
        break;
      case FormType.Depot:
        formTemplateId = this.selectedDepotForm?.id;
        templateVersion = this.selectedDepotForm?.templateVersion;
        templateName = this.selectedDepotForm?.templateName;
        this._appsService.logInfo(formTemplateId + " li forma ait depolar listelendi");
        break;
      case FormType.Region:
        formTemplateId = this.selectedRegionForm?.id;
        templateVersion = this.selectedRegionForm?.templateVersion;
        templateName = this.selectedDepotForm?.templateName;
        this._appsService.logInfo(formTemplateId + " li forma ait bölgeler listelendi");
        break;
      case FormType.Default:
        formTemplateId = this.selectedDefaultForm?.id;
        templateVersion = this.selectedDefaultForm?.templateVersion;
        templateName = this.selectedDefaultForm?.templateName;
        this._appsService.logInfo(formTemplateId + " li forma ait anketler listelendi");
        break;
    }

    this._appsService.leftSidebarControl.next({
      state: 'open',
      type: type,
      formTemplateId: formTemplateId,
      templateVersion: templateVersion,
      templateName: templateName,
    });
    //this.disableMouseLeave = true;
    this.sidenavWidth = this.closedSidenavWith;
    //this._appsService.sidenavToggleState.next(false);
    this.sideMenuList = this.adminSideMenuAuthControl();
  }

  onScroll(event: any): void {
    const container = event.target;

    // Check if user has scrolled to the bottom
    if (container.scrollTop + container.clientHeight >= container.scrollHeight - 10) {
      this.loadMoreProjects(); // Adjust to prevent off-by-one issues
    }
  }

  loadMoreProjects(): void {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = this.currentPage * this.itemsPerPage;

    const nextItems = this.projects.slice(startIndex, endIndex);
    this.displayedProjects = [...this.displayedProjects, ...nextItems];

    this.currentPage++;
  }

  dynamicMapOperations(type) {
    this._appsService.rightSidebarControl.next({
      state: 'open',
      type: type,
      operation: 'create',
    });
  }

  filterProject() {
    return this._appsService?.projects?.filter(item =>
      item?.projectName.toLowerCase().includes(this.searchProjectName?.toLowerCase())
    );
  }


  setTruncateLimit() {
    this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small, Breakpoints.Medium, Breakpoints.Large, Breakpoints.XLarge]).subscribe(result => {
      if (this._appsService.classes === 'global-large') {
        if (result.matches && result.breakpoints[Breakpoints.XSmall]) {
          this.truncateLimit = 15;
        } else if (result.matches && result.breakpoints[Breakpoints.Small]) {
          this.truncateLimit = 30;
        }
        else if (result.matches && result.breakpoints[Breakpoints.XLarge]) {
          this.truncateLimit = 30;
        }
        else {
          this.truncateLimit = 20;
        }
      } else if (this._appsService.classes === 'global-medium') {
        this.truncateLimit = 40;
      } else {
        this.truncateLimit = 30;
      }
    });
  }

  addOrUpdateUserFormTemplate(userFormTemplate: any) {
    this._request.addOrUpdateUserFormTemplate(userFormTemplate).then(res => {
      if (res?.code == 1) {
      }
    })
  }
}
